import { IPriceProductsApiResponse } from '@packlink/packlink-sdk';
import { IServiceState, IUpsell, UpsellType } from '@types';

export const calculateUpsellOptions = (
    contentValue: number,
    service: IServiceState,
    products: IPriceProductsApiResponse,
    showAdditionalInsurance?: boolean,
): IUpsell[] => {
    const upsells: IUpsell[] = [];
    const insurance = products.insurance;
    const proofOfDelivery = products.proof_of_delivery;
    const adultSignature = products.adult_signature;
    const baseCoverage = (insurance && insurance.base_coverage) || 0;
    const insurable = showAdditionalInsurance && contentValue > baseCoverage;

    if (adultSignature) {
        upsells.push({
            amount: adultSignature.total_price || 0,
            coverage: 0,
            currency: adultSignature.currency ?? 'EUR',
            type: UpsellType.ADULT_SIGNATURE,
        });
    }

    if (insurance && insurable) {
        const insuranceAmount =
            (insurance.total_price ?? 0) + (proofOfDelivery ? +(proofOfDelivery.total_price || 0) : 0);

        upsells.push({
            amount: insuranceAmount,
            coverage: insurance.insured || 0,
            currency: insurance.currency ?? 'EUR',
            type: UpsellType.ENHANCED,
        });
    }

    if (proofOfDelivery && proofOfDelivery.total_price !== 0) {
        upsells.push({
            amount: proofOfDelivery.total_price || 0,
            coverage: Math.min(baseCoverage, contentValue),
            currency: proofOfDelivery.currency ?? 'EUR',
            type: UpsellType.PROOF_OF_DELIVERY,
        });
    }

    // Functional debt: If the base coverage is 0 and showAdditionalInsurance is true, the standard insurance should be displayed
    if (baseCoverage > 0 || (baseCoverage == 0 && showAdditionalInsurance)) {
        upsells.push({
            amount: 0,
            coverage: Math.min(baseCoverage, contentValue),
            currency: service.currency,
            type: UpsellType.STANDARD,
        });
    }

    return upsells;
};
